"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var view_1 = require("@catalytic/view");
var unist_util_visit_1 = tslib_1.__importDefault(require("unist-util-visit"));
function tableCellAlign() {
    return function transformer(node) {
        unist_util_visit_1.default(node, view_1.NodeType.TABLE, function (node) {
            var table = node;
            var align = table.align;
            if (!Array.isArray(align) || !Array.isArray(table === null || table === void 0 ? void 0 : table.children)) {
                return;
            }
            table.children.forEach(function (child) {
                var row = child;
                if (!Array.isArray(row === null || row === void 0 ? void 0 : row.children)) {
                    return;
                }
                row.children.forEach(function (cell, i) {
                    cell.align = align[i];
                });
            });
        });
    };
}
exports.default = tableCellAlign;
//# sourceMappingURL=table-cell-align.js.map